import React from 'react';
import { useLiveResultsContext } from '../context/LiveResultsContext';
import './connectionStatus.css';

const STATUS_CONFIG = {
  connected:    { label: 'Połączony',                  icon: 'dot',     },
  connecting:   { label: 'Łączenie…',                  icon: 'spinner', },
  disconnected: { label: 'Trwa ponowne łączenie…',     icon: 'spinner', },
};

const ConnectionStatusIndicator = () => {
  const { connectionState } = useLiveResultsContext();
  const state = connectionState || 'connecting';
  const { label, icon } = STATUS_CONFIG[state] || STATUS_CONFIG.connecting;

  return (
    <div
      className={`connection-indicator connection-indicator--${state}`}
      role="status"
      aria-live="polite"
    >
      <span
        className={`connection-indicator__icon connection-indicator__icon--${icon}`}
        aria-hidden="true"
      />
      <span className="connection-indicator__label">{label}</span>
    </div>
  );
};

export default ConnectionStatusIndicator;
